/* ============================================================
 * Contact Tabs — Tab-Umschaltung + sessionStorage-Befüllung
 *
 * Lebenszyklus pro <section class="contact-tabs">:
 *   1. Tab-Buttons (data-target="…") schalten Panels um und
 *      merken den letzten aktiven Tab in sessionStorage.
 *   2. Beim Laden wird sessionStorage["pcw-kalkulation"]
 *      gelesen (geschrieben vom Preisrechner-Wizard) und in
 *      die richtigen Felder eingetragen – plus Tab-Auswahl
 *      basierend auf state.kundentyp.
 * ============================================================ */

(function () {
  'use strict';

  const STORAGE_KEY_PCW = 'pcw-kalkulation';
  const STORAGE_KEY_TAB = 'contact-tabs:active';

  function $(sel, scope) {
    return (scope || document).querySelector(sel);
  }
  function $$(sel, scope) {
    return Array.from((scope || document).querySelectorAll(sel));
  }

  function setValue(el, value) {
    if (!el || value == null || value === '') return;
    // Nur überschreiben, wenn das Feld leer ist (User-Eingaben respektieren).
    if (el.value && el.value.trim() !== '') return;
    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function readPcwData() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY_PCW);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (_) {
      return null;
    }
  }

  function buildMessageFromPositionen(data) {
    if (!data || !Array.isArray(data.positionen) || data.positionen.length === 0) {
      return '';
    }
    const lines = ['Anfrage aus dem Preisrechner:', ''];

    // Eckdaten aus dem geführten Assistenten (Schritt 1). Feldnamen synchron zum
    // Producer in price-calculator-wizard.js → angebotAnfordern().
    const eckdaten = [
      ['Anzahl Immobilien', data.immoCount],
      ['Wohneinheiten gesamt', data.gesamtWE],
      ['Benötigte Datensammler', data.gatewayMenge],
    ].filter(([, value]) => value != null && value !== '');

    // Aufschlüsselung je Immobilie: Wohneinheiten + empfohlener Gerätetyp (Label
    // kommt fertig vom Wizard, damit die Editor-Bezeichnungen nicht divergieren).
    const immobilien = Array.isArray(data.properties) ? data.properties : [];

    if (eckdaten.length || immobilien.length) {
      lines.push('Ihre Angaben:');
      eckdaten.forEach(([label, value]) => lines.push(`- ${label}: ${value}`));
      immobilien.forEach((p, i) => {
        const teile = [`${p.we != null && p.we !== '' ? p.we : '?'} WE`];
        if (p.geraetLabel) teile.push(p.geraetLabel);
        lines.push(`- Immobilie ${i + 1}: ${teile.join(' · ')}`);
      });
      lines.push('');
    }

    lines.push('Kalkulierte Positionen:');
    data.positionen.forEach((p) => {
      const betrag = typeof p.betrag === 'number'
        ? p.betrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
        : p.betrag;
      lines.push(`- ${p.label}: ${betrag} (${p.periode || '–'})`);
    });
    lines.push('', 'Bitte erstellen Sie uns ein passendes Angebot.');
    return lines.join('\n');
  }

  function activateTab(root, target) {
    const buttons = $$('.contact-tabs__tab-btn', root);
    const panels = $$('.contact-tabs__panel', root);

    buttons.forEach((b) => {
      const isActive = b.dataset.target === target;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      b.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((p) => {
      const isActive = p.dataset.panel === target;
      p.classList.toggle('is-hidden', !isActive);
      p.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    try {
      sessionStorage.setItem(STORAGE_KEY_TAB, target);
    } catch (_) { /* ignore */ }
  }

  function setupTabs(root) {
    const buttons = $$('.contact-tabs__tab-btn', root);
    if (buttons.length === 0) return;

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => activateTab(root, btn.dataset.target));
    });

    // Initialer Zustand: gemerkter Tab > erster Tab
    let initial = null;
    try {
      initial = sessionStorage.getItem(STORAGE_KEY_TAB);
    } catch (_) { /* ignore */ }

    const validTargets = buttons.map((b) => b.dataset.target);
    if (!initial || !validTargets.includes(initial)) {
      initial = validTargets[0];
    }
    activateTab(root, initial);
  }

  function applyPcwData(root, pcwData) {
    if (!pcwData) return;

    // Kundentyp → Ziel-Panel. Default: Privat, wenn unbekannt.
    let targetPanel = 'private';
    if (pcwData.kundentyp === 'business' || pcwData.kundentyp === 'geschaeft') {
      targetPanel = 'business';
    }

    activateTab(root, targetPanel);

    // NUR das passende Panel befüllen – wechselt der User später
    // den Tab, soll das andere Formular leer sein.
    const panel = $(`.contact-tabs__panel[data-panel="${targetPanel}"]`, root);
    if (!panel) return;

    const fullName = [pcwData.vorname, pcwData.nachname].filter(Boolean).join(' ').trim();
    const message = buildMessageFromPositionen(pcwData);

    setValue($('input[name="contact[name]"]', panel), fullName);
    setValue($('input[name="contact[first_name]"]', panel), pcwData.vorname);
    setValue($('input[name="contact[last_name]"]', panel), pcwData.nachname);
    setValue($('input[name="contact[email]"]', panel), pcwData.email);
    setValue($('textarea[name="contact[body]"]', panel), message);
  }


  let handlersBound = false;
  function bindFormHandlers() {
    if (handlersBound) return;
    handlersBound = true;

    // `invalid` bubblet nicht → Capture-Phase.
    document.addEventListener(
      'invalid',
      (event) => {
        const form = event.target && event.target.closest
          ? event.target.closest('.contact-tabs__form')
          : null;
        if (form) form.classList.add('is-validated');
      },
      true
    );
  }

  /**
   * Reload-Pfad (z. B. nach hCaptcha): Liquid rendert die Erfolgsbox
   * serverseitig sichtbar (form.posted_successfully?). Den dazugehörigen
   * Tab aktiv schalten, damit die Bestätigung im sichtbaren Panel liegt.
   */
  function activatePanelWithVisibleSuccess(root) {
    const visibleSuccess = $('[data-success]:not([hidden])', root);
    if (!visibleSuccess) return;
    const panel = visibleSuccess.closest('.contact-tabs__panel');
    if (panel && panel.dataset.panel) activateTab(root, panel.dataset.panel);
  }

  function focusOnSuccess(root) {
    // Nach dem Reload (?contact_posted=true) rendert Liquid die Erfolgsbox
    // sichtbar. Dorthin scrollen + Fokus setzen, damit die Bestätigung
    // (auch für Screenreader) wahrgenommen wird.
    const notice = $('.contact-tabs__notice--success:not([hidden])', root);
    if (notice) {
      notice.setAttribute('tabindex', '-1');
      notice.focus({ preventScroll: false });
      notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function init() {
    // Submit-/Validierungs-Handler einmal global (delegiert) binden –
    // unabhängig davon, wie oft Sections neu gerendert werden.
    bindFormHandlers();

    $$('.contact-tabs').forEach((root) => {
      setupTabs(root);

      const pcw = readPcwData();
      if (pcw) {
        applyPcwData(root, pcw);
        // Daten wurden konsumiert → entfernen, damit sie nach Reload nicht erneut greifen
        try { sessionStorage.removeItem(STORAGE_KEY_PCW); } catch (_) { /* ignore */ }
      }

      activatePanelWithVisibleSuccess(root);
      focusOnSuccess(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
